

export default {
    computed : {
        example_bikes : function(){
            return [
                {
                    label: this.$t('bikes.used-bike'),
                    price_min: 200,
                    price_max: 400
                },{
                    label: this.$t('bikes.new-low-end-bike'),
                    price_min: 300,
                    price_max: 500
                },{
                    label: this.$t('bikes.used-commuter-bike'),
                    price_min: 300,
                    price_max: 600
                },{
                    label: this.$t('bikes.new-commuter-bike'),
                    price_min: 600,
                    price_max: 800
                },{
                    label: this.$t('bikes.new-low-end-e-bike'),
                    electric : true,
                    price_min: 600,
                    price_max: 800
                },{
                    label: this.$t('bikes.used-e-bike'),
                    electric : true,
                    price_min: 500,
                    price_max: 1200
                },{
                    label: this.$t('bikes.new-e-bike'),
                    electric : true,
                    price_min: 800,
                    price_max: 3000
                },{
                    label: this.$t('bikes.used-cargo-bike'),
                    price_min: 700,
                    price_max: 1000
                },{
                    label: this.$t('bikes.new-cargo-bike'),
                    price_min: 1000,
                    price_max: 2500
                },{
                    label: this.$t('bikes.new-e-cargo-bike'),
                    electric : true,
                    price_min: 2200,
                    price_max: 4500
                },{
                    label: this.$t('bikes.new-high-end-bike'),
                    price_min: 4000,
                    price_max: 8000
                },{
                    label: this.$t('bikes.new-high-end-e-bike'),
                    electric : true,
                    price_min: 4000,
                    price_max: 8000
                }
            
            ]
            
        },
        vehicles : function(){
            return [
                {
                    label: this.$t('vehicles.car'),
                    value: 'car',
                    fuel_consumption : 7,
                    electric_charge_capacity : 60,
                    electric_charge_distance : 150,
                    movement_type : "driving",
                    speed_floor: 10,
                    speed_ceiling: 100,
                    charge_capacity_min: 10,
                    charge_capacity_max: 150,
                    charge_distance_min: 60,
                    charge_distance_max: 500,
                    
                                            
                },  {
                    label: this.$t('vehicles.motorcycle'),
                    value: 'motorcycle',
                    fuel_consumption : 4,
                    electric_charge_capacity : 20,
                    electric_charge_distance : 90,
                    movement_type : "driving",
                    speed_floor: 10,
                    speed_ceiling: 100,
                    charge_capacity_min: 5,
                    charge_capacity_max: 50,
                    charge_distance_min: 60,
                    charge_distance_max: 200
                    

                },{
                    label: this.$t('vehicles.e-bicycle'),
                    value: 'e-bicycle',
                    electric_charge_capacity : .4,
                    electric_charge_distance : 50,
                    movement_type : "bicycling",
                    speed_ceiling: 30,
                    speed_floor: 18,

                    charge_capacity_min: .1,
                    charge_capacity_max: 1.1,
                    charge_distance_min: 10,
                    charge_distance_max: 300
            
                }, {
                    label: this.$t('vehicles.bicycle'),
                    value: 'bicycle',
                    movement_type : "bicycling",
                    speed_ceiling: 30,
                    speed_floor: 16,

                }, {
                    label: this.$t('vehicles.public-transportation'),
                    value: 'public',
                    movement_type : "transit",
                    speed_ceiling: 30,


                }, {
                    label: this.$t('vehicles.other'),
                    value: 'other',
                    movement_type : "bicycling", // consider that other forms of transportation will advance at bike-ish speed
                }
            ]
        },
        
        other_vehicles : function(){
            return [
                {
                    label: this.$t('other_vehicles.walk'),
                    value: 'walk',
                    speed_floor: 3,
                    speed_ceiling: 9,

                }, {
                    label: this.$t('other_vehicles.foot-scooter'),
                    value: 'foot-scooter',
                    speed_ceiling: 14

                }, {
                    label: this.$t('other_vehicles.foot-scooter-e'),
                    value: 'e-foot-scooter',
                    speed_floor: 12,

                },
                {label: this.$t('other_vehicles.hoverboard'), value: 'hoverboard'},
                {label: this.$t('other_vehicles.rollerblade'), value: 'rollerblade'},
                {label: this.$t('other_vehicles.skateboard'), value: 'skateboard'},
                {
                    label: this.$t('other_vehicles.e-monocycle'),
                    value: 'e-monocycle',
                    speed_floor: 12,

                },
                {label: this.$t('other_vehicles.boat'), value: 'boat'},
                {label: this.$t('other_vehicles.ski'), value: 'ski'},
                {
                    label: this.$t('other_vehicles.horse'),
                    value: 'horse',
                    speed_ceiling: 10
                },
                {label: this.$t('other_vehicles.unicorn'), value: 'unicorn'}
            ]
        },

        energy_sources: function(){
            if (this.vehicle === 'motorcycle'){
                return [
                    {label: this.$t('energy_sources.gas'), value: 'gas'},
                    {label: this.$t('energy_sources.electric'), value: 'electric'},
                ]
            }
            
            return  [
                {label: this.$t('energy_sources.gas'), value: 'gas'},
                {label: this.$t('energy_sources.diesel'), value: 'diesel'},
                {label: this.$t('energy_sources.hybrid'), value: 'hybrid'},
                {label: this.$t('energy_sources.electric'), value: 'electric'},
               // {label: this.$t('energy_sources.lpg'), value: 'lpg'}
            ]
        },
        min_fuel_consumption : function(){
            if (this.vehicle === 'motorcycle'){
                return 1.5
            }
            return 2.8
        },
        max_fuel_consumption : function(){
            if (this.vehicle === 'motorcycle'){
                return 9.5
            }
            return 24
        }
    },
    methods: {
    
        
        vehicle_can_go_thru_traffic: function(vehicle){
            
            
        },
        
        

    }
}


